module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Birrhard-c61815a776c1a5c53fea42431ccbb539.svg";